import React, { useState } from "react";
import { Button, Modal, Form, Row, Col, Input, Radio } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { eContent } from "../../constant/field-names";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";

export const EditRecallModal = ({ dataSource, setDataSource, index }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    form.setFieldsValue(dataSource[index]);
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    // const test = await form.validateFields();
    const values = form.getFieldsValue();
    let newDataSource = [...dataSource];
    newDataSource[index] = values;

    setDataSource(newDataSource);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={showModal}>
        <div className="mb-1">
          <EditOutlined rev="data" />
        </div>
      </Button>

      <Modal
        title="CHỈNH SỬA CCDC CẦN THU HỒI"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <Col span={24}>
              <StyledTitle level={4}>Tên CCDC <span className="text-danger">(*)</span></StyledTitle>
              <Form.Item
                name={eContent.toolName}
                rules={[{ required: true, message: "Nhập tên CCDC" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <StyledTitle level={4}>Mã CCDC <span className="text-danger">(*)</span></StyledTitle>
              <Form.Item
                name={eContent.toolId}
                rules={[{ required: true, message: "Nhập mã CCDC" }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={4}>ĐVT <span className="text-danger">(*)</span></StyledTitle>
              <Form.Item
                name={eContent.Dram}
                rules={[{ required: true, message: "Nhập ĐVT" }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={4}>Số lượng <span className="text-danger">(*)</span></StyledTitle>
              <Form.Item
                name={eContent.Quantity}
                rules={[
                  { required: true, message: "Nhập số lượng" },
                  {
                    message: "Giá trị không hợp lệ",
                    pattern: new RegExp(/^[1-9][0-9]*$/),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={4}>Lý do <span className="text-danger">(*)</span></StyledTitle>
              <Form.Item
                name={eContent.reason}
                rules={[{ required: true, message: "Nhập lí do" }]}
              >
                <Radio.Group>
                  <Radio value={"Hư hỏng"}>Hư hỏng</Radio>
                  <Radio value={"Không có nhu cầu sử dụng"}>
                    Không có nhu cầu sử dụng
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
